<template>
  <div class="relative">
    <VButton
      class="toggle-view-button"
      data-testid="toggle-view-btn"
      data-intercom-target="toggle-view-button"
      variant="copper-borderless"
      :class="buttonClass"
      no-shadow="noShadow"
      :disabled="disabled"
      @click="$emit('toggle-view-mode')"
    >
      <Squares2X2Icon v-if="!isGridView" class="w-6 h-6" />
      <Bars3Icon v-else class="w-6 h-6" />
      <span class="xl_hidden">{{ isGridView ? 'List' : 'Sorter' }}</span>
      <span class="hidden xl_inline">{{ isGridView ? 'List View' : 'Slide Sorter' }}</span>
    </VButton>
  </div>
</template>

<script lang="ts" setup>
import { Squares2X2Icon, Bars3Icon } from '@heroicons/vue/24/solid'

defineProps({
  buttonClass: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  isGridView: {
    type: Boolean,
    default: false,
  },
})

defineEmits(['toggle-view-mode'])
</script>
